import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || '';

export function SEOHead({ title, description, ogImage, ogType, noApi }) {
  const location = useLocation();
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (noApi || title) return;
    axios.get(`${API}/seo/meta?path=${encodeURIComponent(location.pathname)}`)
      .then(r => setMeta(r.data))
      .catch(() => {});
  }, [location.pathname, noApi, title]);

  const m = meta || {};
  const t = title || m.title || 'Nuvanta TradePath | Supply Chain Intelligence';
  const d = description || m.description || 'Supply chain risk intelligence for Australian businesses.';
  const img = ogImage || m.og_image || `${API}/seo/og-image`;
  const type = ogType || m.og_type || 'website';
  const canonical = m.canonical || `https://nuvantatradepath.com.au${location.pathname}`;

  return (
    <Helmet>
      <html lang="en-AU" />
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en-AU" href={canonical} />
      <link rel="alternate" hrefLang="x-default" href={canonical} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Nuvanta TradePath" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}

// ── GA4 helpers ──

export function trackEvent(eventName, params = {}) {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
}

export function initGA4() {
  if (!GA_ID) return;
  // Load gtag script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: true });
}
